<template>
    <transition name="slide-fade" >


        <v-toolbar app  clipped-right v-if='!dense' key="1" class="nav-menu" color="primary">

                <img :src="logo" @click="goHome" class="logo">

            <v-spacer></v-spacer>



<!--  ---------------------------------------------------------------------------------------------------- -->
            <v-toolbar-side-icon v-if="collapsenav" dark @click="$emit('nav-drawer')"></v-toolbar-side-icon>

            <v-toolbar-items v-if="$route.path == '/' && !collapsenav" class="hidden-xs-only">
                <v-btn class="text-none" color="accent" flat @click="scroll('quemsomos')"> <strong>Quem Somos</strong></v-btn>
                <v-btn class="text-none" color="accent" flat @click="scroll('solucoes')"> <strong>Soluções</strong></v-btn>
                <v-btn class="text-none" color="accent" flat @click="scroll('advogados')"> <strong>Advogados</strong></v-btn>
                <!-- <v-btn class="text-none" color="accent" flat @click="scroll('publicacoes')"> <strong>Publicações</strong></v-btn> -->
                <v-btn class="text-none" color="accent" flat @click="scroll('contato')"> <strong>Contato</strong></v-btn>
                <v-btn class="grey-darken-3--text text-none" flat @click="$emit('manual-eleicoes')"> <strong>Guia Eleições 2026</strong></v-btn>

                <v-btn v-show="loggedIn" class="text-none" color="accent" flat href="/admin/emails"> <strong>Emails</strong> </v-btn>
                <v-btn v-show="loggedIn" class="text-none" color="accent" flat @click.prevent="logOut"> <strong>Sair</strong> </v-btn>
            </v-toolbar-items>

            <v-toolbar-items v-if="$route.path != '/' && !collapsenav" class="hidden-xs-only">
                <v-btn class="text-none" color="accent" flat href="/#quemsomos"> <strong>Quem Somos</strong></v-btn>
                <v-btn class="text-none" color="accent" flat href="/#solucoes"> <strong>Soluções</strong></v-btn>
                <v-btn class="text-none" color="accent" flat href="/#advogados"> <strong>Advogados</strong></v-btn>
                <!-- <v-btn class="text-none" color="accent" flat href="/#publicacoes"> <strong>Publicações</strong></v-btn> -->
                <v-btn class="text-none" color="accent" flat href="/#contato"> <strong>Contato</strong></v-btn>
                <v-btn class="grey-darken-3--text text-none" flat @click="$emit('manual-eleicoes')"> <strong>Guia Eleições 2026</strong></v-btn>

                <v-btn v-show="loggedIn" class="text-none" color="accent" flat href="/admin/emails"> <strong>Emails</strong> </v-btn>
                <v-btn v-show="loggedIn" class="text-none" color="accent" flat @click.prevent="logOut"> <strong>Sair</strong> </v-btn>

            </v-toolbar-items>
        </v-toolbar>

        <v-toolbar app v-else dense key="2" class="dense-header" color="primary">
            <img :src="logo"  @click="goHome" class="logo">

            <v-spacer style="{height = 48px !important;}"></v-spacer>

            <v-toolbar-side-icon  v-if="collapsenav"  color="accent" @click="$emit('nav-drawer')"></v-toolbar-side-icon>

            <v-toolbar-items v-if="$route.path == '/' && !collapsenav" class="hidden-xs-only">
                <v-btn class="text-none" color="accent" flat @click="scroll('quemsomos')"> <strong>Quem Somos</strong></v-btn>
                <v-btn class="text-none" color="accent" flat @click="scroll('solucoes')"> <strong>Soluções</strong></v-btn>
                <v-btn class="text-none" color="accent" flat @click="scroll('advogados')"> <strong>Advogados</strong></v-btn>
                <!-- <v-btn class="text-none" color="accent" flat @click="scroll('publicacoes')"> <strong>Publicações</strong></v-btn> -->
                <v-btn class="text-none" color="accent" flat @click="scroll('contato')"> <strong>Contato</strong></v-btn>
                <v-btn class="grey-darken-3--text text-none" flat @click="$emit('manual-eleicoes')"> <strong>Guia Eleições 2026</strong></v-btn>

                <v-btn v-show="loggedIn" class="text-none" color="accent" flat href="/admin/emails"> <strong>Emails</strong> </v-btn>
                <v-btn v-show="loggedIn" class="text-none" color="accent" flat @click.prevent="logOut"> <strong>Sair</strong> </v-btn>
            </v-toolbar-items>

            <v-toolbar-items v-if="$route.path != '/' && !collapsenav"  class="hidden-xs-only">
                <v-btn class="text-none" color="accent" flat href="/#quemsomos"> <strong>Quem Somos</strong></v-btn>
                <v-btn class="text-none" color="accent" flat href="/#solucoes"> <strong>Soluções</strong></v-btn>
                <v-btn class="text-none" color="accent" flat href="/#advogados"> <strong>Advogados</strong></v-btn>
                <!-- <v-btn class="ext-none" color="accent" flat href="/#publicacoes"> <strong>Publicações</strong></v-btn> -->
                <v-btn class="text-none" color="accent" flat href="/#contato"> <strong>Contato</strong></v-btn>
                <v-btn class="grey-darken-3--text text-none" flat @click="$emit('manual-eleicoes')"> <strong>Guia Eleições 2026</strong></v-btn>

                <v-btn v-show="loggedIn" class="text-none" color="accent" flat href="/admin/emails"> <strong>Emails</strong> </v-btn>
                <v-btn v-show="loggedIn" class="text-none" color="accent" flat @click.prevent="logOut"> <strong>Sair</strong> </v-btn>
            </v-toolbar-items>  
        </v-toolbar>
    </transition>
</template>

<script>
import { VToolbar, VBtn} from 'vuetify/lib'
import base from '../plugins/firebase'
import logo from '../assets/headerlogo.png'
import router from '../router'

export default {
    components: {
        VToolbar,
        VBtn,
    },

    props: ['dense', 'collapsenav'],

    data() {
        return{
            logo: logo,
            loggedIn: false,
            scrolled: false,

            options: {
                duration: 400,
                easing: 'easeOutQuad'
            },

            window: {
                width: 0,
                height: 0
            },
        }
    },

    methods: {
        logOut() {
            base.auth().signOut().then( () => {
                this.loggedIn = false
            })
        },

        goHome(){
            router.push({ path: '/' })
        },
        
        scroll(label){
            document.getElementById(label).scrollIntoView({
                behavior: 'smooth'
            });
        },

        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        },
    },

    created() {
        window.addEventListener('resize', this.handleResize);
        base.auth().onAuthStateChanged((user) => {
            if (user) {
                this.loggedIn = true
            } else {
                this.loggedIn = false
            }
        });

    }
}
</script>

<style scoped>
.v-btn {
    height: 50px !important;
    border-radius: 5px !important;
}

.dense-header .v-btn{
    height: 48px !important;
}

.dense-header .spacer{
    height: 48px !important;
}

.slide-fade-enter-active  {
  transition: all .4s ease-out;
}

.slide-fade-leave-active {
  transition: all .5s ease-in;
}
.slide-fade-enter, .slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}

.logo{
    max-width: 75%;
    max-height: 75%;
    object-fit: contain;

    cursor: pointer;
}
</style>
